import {Component, ViewChild} from '@angular/core';
import {TranslateService} from 'ng2-translate/ng2-translate';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  constructor(translate: TranslateService) {
    translate.setDefaultLang('de');
    translate.use('de');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts